import { render, staticRenderFns } from "./goods-in-v1.vue?vue&type=template&id=4c2c419a"
import script from "./goods-in-v1.vue?vue&type=script&lang=js"
export * from "./goods-in-v1.vue?vue&type=script&lang=js"
import style0 from "./goods-in-v1.vue?vue&type=style&index=0&id=4c2c419a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports